<template>
  <div class="wrapper flex">
    <div class="pensure-spinner" :style="style" />
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    color: {
      type: String,
      default: '#606060',
    },
    size: {
      type: Number,
      default: 75,
    },
  },
  computed: {
    style(): string {
      const styles = [
        `border-top: ${2 + this.size / 30}px solid ${this.color}`,
        `border-right: ${2 + this.size / 30}px solid transparent;`,
        `width: ${this.size}px`,
        `height: ${this.size}px`,
      ];
      return styles.join('; ');
    },
  },
});
</script>

<style></style>
